import { css, html } from "lit";
import { when } from "lit-html/directives/when.js";
import "../../atom/Icon/index.js";
import "../IconButton/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { getClasses, getTextClasses } from "./utils.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./tag.selectors.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { concatClasses } from "../../../helpers/concatClasses/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfTag = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.dsf_selected = false;
    this.dsf_closable = false;
    this.dsf_interactive = false;
    this.dsf_size = "medium";
  }
  handleClose() {
    this.emit("close");
  }
  handleCloseClick() {
  }
  render() {
    const iconSize = this.dsf_size === "small" ? "h-12 w-12" : "h-14 w-14";
    const leftIcon = when(
      this.dsf_icon_left,
      () => html`<dsf-icon
          dsf_name="${ifDefined(this.dsf_icon_left)}"
          class=${`${iconSize}`}
        ></dsf-icon>`
    );
    const rightIcon = when(
      this.dsf_icon_right,
      () => html`<dsf-icon
          dsf_name="${ifDefined(this.dsf_icon_right)}"
          class=${`-mr-4 ml-4 ${iconSize}`}
        ></dsf-icon>`
    );
    const buttonClasses = ["-mr-8"];
    if (this.dsf_size === "small") {
      buttonClasses.push("condensed-button");
    }
    const closeButton = when(
      this.dsf_closable,
      () => html`<dsf-icon-button
        class=${concatClasses(buttonClasses)}
        dsf_icon="X"
        dsf_size="small"
        dsf_title="Close"
        ?disabled=${this.disabled}
        dsf_level="neutral"
        ${testingAttr(TestingAttrs.closeButton)}
        @mousedown=${this.handleClose}
        @click=${this.handleCloseClick}
      ></dsf-icon-button>`
    );
    const classes = getClasses(this);
    const textClasses = getTextClasses(this);
    const content = html`${leftIcon}
      <span class=${textClasses}><slot></slot></span>
      ${rightIcon} ${closeButton}`;
    return this.dsf_interactive ? html`
          <button class="${classes}" ?disabled=${this.disabled} data-skeleton>${content}</button>
        ` : html`<div class="${classes}" data-skeleton>${content}</div>`;
  }
};
DsfTag.styles = [
  ...BaseComponent.styles,
  css`
      /* force smaller height to avoid overlap with tag's border */
      .condensed-button::part(button) {
        height: calc(2.2 * var(--dsf-base-size));
      }
    `
];
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTag.prototype, "disabled", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTag.prototype, "dsf_selected", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTag.prototype, "dsf_closable", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTag.prototype, "dsf_interactive", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTag.prototype, "dsf_icon_left", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTag.prototype, "dsf_icon_right", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTag.prototype, "dsf_size", 2);
__decorateClass([
  preventDefault
], DsfTag.prototype, "handleClose", 1);
__decorateClass([
  preventDefault
], DsfTag.prototype, "handleCloseClick", 1);
DsfTag = __decorateClass([
  defineElement("dsf-tag")
], DsfTag);
export {
  DsfTag
};
